<template>
 <v-dialog
     v-bind="$attrs"
     v-model="showDialog"
     width="650"
   >
     <template v-slot:default="dialog">
       <v-card>
          <v-card-title class="pa-2">
          <span class="text-h5">电子签名</span>
          <v-spacer></v-spacer>
          <v-btn dark fab color="primary" depressed text v-if="close" small @click="dialog.value = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
         <v-card-text class="pa-2">
          <v-card>
             <vue-esign
              v-if="show"
              ref="esign"
              :height="200"
              :width="width"
              :isCrop="isCrop"
              :lineWidth="lineWidth"
              :lineColor="lineColor"
              :bgColor.sync="bgColor"
              />
          </v-card>
          <v-card-actions class="pr-0 mt-2">
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click="handleReset">清除</v-btn>
            <v-btn color="primary" dark :loading="loading" @click="handleSubmit">确认</v-btn>
          </v-card-actions>
         </v-card-text>
       </v-card>
     </template>
   </v-dialog>
</template>

<script>

  export default {
    name: 'MarerialEsign',

    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      close: {
        type: Boolean,
        default: true
      },
    },
    data() {
      return {
        loading: false,
        showDialog: this.dialog,
        lineWidth: 7,
        lineColor: '#000000',
        bgColor: '',
        resultImg: '',
        isCrop: false,
        width: 0,
        show: false
      }
    },
    watch: {
      showDialog (val) {
        this.$emit('on-dialog-change', val)
      },
      dialog (val) {
        this.showDialog = val
        if (val) {
          this.changeHeight()
          this.resultImg = ''
        }
      }
    },
    methods: {
      handleSubmit() {
        this.loading = true
        // 使用生成器调用把签字的图片转换成为base64图片格式
        this.$refs.esign.generate().then((res) => {
          this.resultImg = res
        }).catch((err) => {
          // 画布没有签字时会执行这里提示一下
          console.log(err)
          this.$dialog.notify.warning('请签名后再提交', { position: 'top-right', timeout: 4000 })
          this.loading = false
        })
        // 在这里向后端发请求把转换后的base64文件传给后端，后端接收以后再转换成图片做静态图片存储
        // 当然也可以把base64转成流文件blob格式的，类似上传给后端这样，具体哪种方式看后端要求
        setTimeout(() => {
          this.loading = false
          if (this.resultImg) {
            this.showDialog = false
            this.$emit('on-success', this.resultImg)
          }
        }, 200)
      },
      handleReset() { // 清除
        if (this.$refs.esign) {
          this.$refs.esign.reset()
        }
      },
      changeHeight() {
        this.width = window.innerWidth - 65
        this.show = true
      }
    },
    mounted() {
      // 监听自适应
      window.addEventListener('resize', this.changeHeight)
      this.changeHeight()
    },
    beforeDestroy() {
      // 移除绑定的listenResizeFn事件监听
      window.removeEventListener("resize", this.changeHeight)
    }
  }
</script>
